const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
const finePointer = window.matchMedia("(hover: hover) and (pointer: fine)");
const desktopPile = window.matchMedia("(min-width: 47.5rem)");

function observeOnce(nodes, options, onEnter) {
  if (!("IntersectionObserver" in window) || !nodes.length) return;
  const io = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      onEnter(entry.target);
      io.unobserve(entry.target);
    }
  }, options);
  for (const node of nodes) io.observe(node);
}

function sheenHero() {
  const slot = document.getElementById("membership-cardslot");
  const sheen = slot?.querySelector("[data-membership-sheen]");
  if (!slot || !sheen || reduce.matches) return;

  observeOnce([slot], { threshold: 0.4 }, () => {
    sheen.classList.add("is-on");
  });

  if (!finePointer.matches) return;
  let frame = 0;
  slot.addEventListener("pointermove", (event) => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      const box = slot.getBoundingClientRect();
      const x = ((event.clientX - box.left) / box.width) * 100;
      sheen.style.setProperty("--membership-sheen-x", `${x}%`);
    });
  });
}

function stackMonths() {
  const months = document.querySelectorAll("[data-membership-month]");
  if (!months.length) return;

  const restack = () => {
    if (reduce.matches || desktopPile.matches) {
      for (const month of months) {
        month.classList.add("is-locked");
        month.classList.remove("is-behind");
      }
      return;
    }
    let front = -1;
    months.forEach((month, index) => {
      const stickyTop = Number.parseFloat(getComputedStyle(month).top) || 0;
      const stuck = month.getBoundingClientRect().top <= stickyTop + 1;
      month.classList.toggle("is-locked", stuck);
      if (stuck) front = index;
    });
    months.forEach((month, index) => {
      month.classList.toggle("is-behind", front > index);
    });
  };

  restack();
  if (reduce.matches || desktopPile.matches || !("IntersectionObserver" in window)) return;
  const io = new IntersectionObserver(restack, {
    threshold: [0, 0.15, 0.4, 0.7, 1],
    rootMargin: "160px 0px 160px 0px",
  });
  for (const month of months) io.observe(month);
}

sheenHero();
stackMonths();
